module.exports = __webpack_public_path__ + "img/Greenleaf.48840a36.jpg";